import * as React from 'react';
import { createRoot } from 'react-dom/client';
import './reset.css';

import App from './App';
import './styles.less';

const container = document.getElementById('app');
const root = createRoot(container!);
root.render(<App />);